export const pagesNames = {
  landingPage: 'landingPage',
  offerPage: 'offerPage',
  footer: 'footer'
};
